import { IconKeys } from "dash-ui";
import { RoutesPath } from "flow-components/routes/routes";

export const sidebarItemsList: {
  label: string;
  icon?: IconKeys;
  disabled?: boolean;
  path: string;
}[] = [
  {
    label: "dashboard",
    icon: "dashboard2",
    path: RoutesPath.Dashboard,
  },
  {
    label: "properties",
    icon: "home1",
    path: RoutesPath.Properties,
  },
  {
    label: "portfolios",
    icon: "folder",
    path: RoutesPath.Portfolios,
  },
  {
    label: "exchange",
    icon: "dashExchange",
    path: RoutesPath.Exchange,
  },
  // {
  //   label: "messages",
  //   icon: "comment",
  //   path: RoutesPath.Messages,
  //   disabled: true,
  // },
  {
    label: "watchlist",
    icon: "favorite",
    path: RoutesPath.Watchlist,
  },
];
